module.exports = __webpack_public_path__ + "static/media/to_answer_btn.16b20cf5.gif";